<template>
  <div class="homeMain">
    <Menu></Menu>
    <div class="right">
      <Top></Top>
      <div class="content">
        <!-- <keep-alive include='add'> -->
          <router-view></router-view>
        <!-- </keep-alive> -->
      </div>
    </div>
  </div>
</template>

<script>
import Menu from './menu/index.vue'
import Top from './top/index.vue'
export default {
  name: 'Home',
  inject:["reload"],
  components:{ Menu,Top },
  data () {
    return {
      
    }
  },
  created(){

  },
  mounted(){
    
  },
  methods: {
    refresh(){
      this.reload()
    }
  },
}
</script>

<style lang='scss' scoped>
.homeMain{
  width: 100vw;
  height: 100vh;
  background: #fff;
  display: flex;
  .right{
    width: calc(100vw - 240px);
  }
    .content{
      border: 1px solid #ccc;
      border-radius: 2px;
      padding: 12px 12px 20px 12px;
      max-width: calc(100vw - 240px);
      max-height: calc(100vh - 60px);
      overflow-y: auto;
      margin: 2px 2px 2px 0;
      background: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue